<div class="modal-container">
  <h2>Question Livrable</h2>
  <form [formGroup]="deliverableQuestionForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="question">Question / Libellé :</label>
      <input id="question" type="text" formControlName="question" placeholder="Ex: Décrivez votre projet musical..." />
      <p *ngIf="getGeneratedVariable()" class="variable-hint">
        Variable pour le prompt : <code>{{ getGeneratedVariable() }}</code>
      </p>
    </div>

    <div class="form-group">
      <label for="description">Description (optionnel) :</label>
      <input id="description" type="text" formControlName="description" placeholder="Texte explicatif affiché sous le titre..." />
    </div>

    <div class="form-group">
      <label for="questionType">Type de question :</label>
      <select formControlName="questionType" id="questionType" (change)="onQuestionTypeChange()">
        <option *ngFor="let type of questionTypes" [value]="type.value">{{ type.label }}</option>
      </select>
    </div>

    <div class="form-group-checkbox">
      <input type="checkbox" formControlName="mandatory" id="mandatory" />
      <label for="mandatory">Question obligatoire</label>
    </div>
    <p class="help-text">Si activé, l'apprenant devra répondre à cette question pour valider ses réponses.</p>

    <div *ngIf="currentQuestionType === 'fillInTheBlank'" class="type-specific-container">
      <label>Texte à trou :</label>
      <p class="help-text">Utilisez le bouton pour ajouter des trous. Les trous seront remplacés par des champs de saisie.</p>
      <textarea formControlName="templateText" rows="4" placeholder="Mon style musical est {{1}} et je vise le public {{2}}"></textarea>
      <app-button size="sm" [outlined]="true" text="Ajouter un trou" (onClick)="addBlank()"></app-button>
    </div>

    <div *ngIf="currentQuestionType === 'table'" class="type-specific-container">
      <label>Colonnes du tableau :</label>
      <div formArrayName="tableColumns" class="columns-container">
        <div *ngFor="let column of tableColumns.controls; let i = index" [formGroupName]="i" class="column-group">
          <input type="text" formControlName="label" placeholder="Nom de la colonne {{ i + 1 }}" />
          <img class="delete" src="../../../../../assets/icons/delete.svg" (click)="removeColumn(i)" />
        </div>
      </div>
      <app-button size="sm" [outlined]="true" text="Ajouter une colonne" (onClick)="addColumn()"></app-button>

      <div class="form-group-checkbox" style="margin-top: 15px;">
        <input type="checkbox" formControlName="firstColumnAsNumbering" id="firstColumnAsNumbering" />
        <label for="firstColumnAsNumbering">Utiliser la 1ère colonne comme numérotation</label>
      </div>
      <p *ngIf="deliverableQuestionForm.get('firstColumnAsNumbering')?.value" class="help-text">
        La 1ère colonne servira de titre pour les numéros de ligne (1, 2, 3...). Pas de saisie pour cette colonne.
      </p>

      <div class="row-labels-section">
        <label>Labels des lignes (optionnel) :</label>
        <p class="help-text">Si renseignés, les lignes auront des labels fixes. Sinon, l'apprenant pourra ajouter des lignes.</p>
        <div formArrayName="tableRowLabels" class="row-labels-container">
          <div *ngFor="let label of tableRowLabels.controls; let i = index" class="row-label-group">
            <input type="text" [formControlName]="i" placeholder="Label ligne {{ i + 1 }}" />
            <img class="delete" src="../../../../../assets/icons/delete.svg" (click)="removeRowLabel(i)" />
          </div>
        </div>
        <app-button size="sm" [outlined]="true" text="Ajouter un label de ligne" (onClick)="addRowLabel()"></app-button>
      </div>

      <div class="table-options">
        <div class="form-group-inline">
          <label for="tableMinRows">Min lignes :</label>
          <input id="tableMinRows" type="number" formControlName="tableMinRows" min="1" />
        </div>
        <div class="form-group-inline">
          <label for="tableMaxRows">Max lignes :</label>
          <input id="tableMaxRows" type="number" formControlName="tableMaxRows" min="1" />
        </div>
      </div>
    </div>

    <div *ngIf="currentQuestionType === 'imageUpload'" class="type-specific-container">
      <label>Options d'upload image :</label>
      <div class="form-group-checkbox">
        <input type="checkbox" formControlName="allowAiGeneration" id="allowAiGeneration" />
        <label for="allowAiGeneration">Autoriser la génération par IA</label>
      </div>
      <p class="help-text">Si activé, l'apprenant pourra choisir de laisser l'IA générer une image au lieu d'en uploader une.</p>
    </div>

    <div class="form-actions">
      <app-button *ngIf="data?.elementInfo" size="sm" color="warn" [outlined]="true" text="Supprimer" (onClick)="deleteQuestion()"></app-button>
      <app-button size="sm" [outlined]="true" text="Annuler" (onClick)="closeDialog()"></app-button>
      <app-button size="sm" text="Valider" type="submit"></app-button>
    </div>
  </form>
</div>
